import axios from "axios";
import { Toast } from "react-native-toast-message/lib/src/Toast";
import translate from "../functions/translate";
export default async function Post(endpoint, data) {
  const url = "https://api.asqtest.ir/";

  return axios
    .post(`https://api.asqtest.ir/${endpoint}`, data, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        origin: "https://manager.asqtest.ir",
      },
    })
    .catch((error) => {
      Toast.show({
        type: "error",
        text1: translate("connection error"),
      });
    });
}
